import { TextDecoration } from "../../../../base/styles";
import clsx from "clsx";

export const SelectTextDecoration = ({ title, value, className, onChange }:{
    title: string,
    value?: TextDecoration,
    className?: string,
    onChange: (value?: TextDecoration) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as TextDecoration;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (    
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={TextDecoration.Underline}>Underline</option>
                <option value={TextDecoration.LineThrough}>Line Through</option>
            </select>
        </div>
    )
}